// 공통
export const POST_LOGIN = '/login/index';
export const POST_LOGOUT = '/logout/index';
export const GET_ACCOUNT = '/account/index';
export const PUT_ACCOUNT = '/account/index';
export const GET_DASHBOARD = '/dashboard/index';
export const GET_LIST = '/list/index';
export const PUT_LIST_SETTING = '/list/setting';
export const GET_EXCEL_DOWNLOAD = '/excel/download';
export const GET_EXCEL_FORM_DOWNLOAD = '/excel/form/download';
export const GET_EXCEL_REPORT_DOWNLOAD = '/excel/report/download';
export const POST_FILE_UPLOAD = '/common/saveFile';
export const POST_EXCEL_UPLOAD = 'common/excel/upload';
export const POST_EXCEL_UPLOAD_BRANCH_REGION = '/common/excel/upload/branch/region';
export const POST_FILE_FORM_UPLOAD = '/file/upload/:doc_type';
export const GET_COMMON_CHECKEMAIL = '/common/checkEmail';
export const GET_COMMON_CHECKPHONE = '/common/checkPhone';
export const GET_COMMON_ID = '/common/checkId';
export const POST_COMMON_SENDMESSAGE = '/common/sendMessage';
export const POST_ORDER_SENDMESSAGE = '/common/sendMessage/order';
export const GET_COMMON_BRANCHLIST = '/common/branchList';
export const GET_COMMON_SCHOOLLIST = '/common/schoolList/:branch_idx';
export const GET_COMMON_TEAMLIST = '/common/teamList';
export const GET_COMMON_AREALIST = '/common/areaList';
export const GET_COMMON_FILE_DOWNLOAD = '/common/download';
export const GET_COMMON_SCHOOL_CANCEL_LIST = '/school/cancel/:branch_idx'; // 해지교육원 리스트
export const GET_COMMON_BOOK_CATEGORY = '/common/book/category';
export const GET_COMMON_BOOK_FIRST = '/common/book/category/booklist';
export const GET_COMMON_PRODUCT_CATEGORY = '/common/product/category'; //물품카테고리 목록
export const POST_COMMON_BOOK_1ST_CATEGORY = '/common/book_1st_category';
export const PUT_COMMON_BOOK_1ST_CATEGORY = '/common/book_1st_category';
export const POST_COMMON_BOOK_2ST_CATEGORY = '/common/book_2st_category';
export const PUT_COMMON_BOOK_2ND_CATEGORY = '/common/book_2st_category';
export const DELETE_COMMON_BOOK_1ST_CATEGORY = '/common/book_1st_category/:idx';
export const DELETE_COMMON_BOOK_2ST_CATEGORY = '/common/book_2st_category/:idx';
export const POST_COMMON_COL_UPDATE = '/common/update';
export const GET_COMMON_BOOK_CLASS = '/common/book/class';
export const GET_COMMON_CKEDITOR_TOKEN = '/common/auth';   // CKEditor Get Token

//주문상세
export const GET_BOOKLIST = '/orderBook/index'; //교재목록
export const GET_BOOK_DELIVERY_LIST = '/orderBook/deliveryinfo'; //엑셀 배송용 출력
export const GET_BOOK_DELIVERY_PDF_LIST = '/orderBook/delivery/pdf'; //PDF 배송용 출력

//통계, 대시보드 등
export const GET_SCHOOL_STATISTICS_ALL = '/school/statistics/all/:tab_type'; // 전체 통계
export const GET_COMMON_INFO_SCHOOL = '/common/info_school/:branch_idx'; //교육원 상태별 현황
export const GET_COMMON_INFO_MEMBER = '/common/info_member/:branch_idx'; //회원 상태별 현황
export const GET_COMMON_INFO_COURCE = '/common/info_cource/:branch_idx'; // 교육 과정별 회원 현황
export const GET_COMMON_INFO_AGE = '/common/info_age/:branch_idx'; // 연령별 회원 현황
export const GET_BOARD_TASK_TOP5 = '/board/task/top5'; // 신규게시물목록 (5개))
export const GET_COMMON_CHECK_BRANCH_NAME = '/common/checkBranch';   // 지사명 중복체크
export const GET_COMMON_CHECK_SCHOOL_NAME = '/common/checkSchool';   // 지사명 중복체크

// 가맹상담
export const POST_STORECOUNSEL = '/storeCounsel/index';
export const GET_STORECOUNSEL_DETAIL = '/storeCounsel/:idx';
export const PUT_STORECOUNSEL = '/storeCounsel/:idx';
export const DELETE_STORECOUNSEL = '/storeCounsel/:idx';
export const POST_DELETE_STORECOUNSEL = '/storeCounsel/delete';
export const GET_STORECOUNSEL = '/storeCounsel/index'; //교육원등록시 사용할 가망상담리스트
export const GET_LINKED_BRANCH = '/storeCounsel/linkedBranch'; // 연결 가능한 지사 찾기

// 입회상담
export const POST_JOINCOUNSEL = '/joinCounsel/index';
export const GET_JOINCOUNSEL_DETAIL = '/joinCounsel/:idx';
export const PUT_JOINCOUNSEL = '/joinCounsel/index';
export const DELETE_JOINCOUNSEL = '/joinCounsel/:idx';
export const PUT_JOINCOUNSEL_APPROVAL = '/joinCounsel/approval';
export const PUT_JOINCOUNSEL_APP_APPROVAL = '/joinCounsel/app/approval';
export const POST_JOINCOUNSEL_SEND_ALIMTALK = '/joinCounsel/sendAlimtalk';
export const GET_MEMBER_FIRST_BOOK = '/joinCounsel/first_book/:join_counsel_idx';

// 강사
export const POST_TEACHER = '/teacher/index';
export const GET_TEACHER_DETAIL = '/teacher/:teacher_idx';
export const PUT_TEACHER = '/teacher/:teacher_idx';
export const PUT_TEACHER_ONLINE_TEST = '/teacher/online_test';
export const PUT_TEACHER_APPROVE_YN = '/teacher/approve_yn';
export const PUT_ACADEMY_COMPLETE_DATE = '/teacher/academy_complete_date';
export const PUT_BRANCH_CHECK_DATE = '/teacher/branch_check_date';

// 회원
export const GET_MEMBER_DETAIL = '/member/:member_idx';
export const PUT_MEMBER = '/member/index';
export const DELETE_MEMBER = '/member/:member_idx';
export const PUT_MEMBER_EXCEPTION = '/member/exception'; //예외교습 일괄수정
export const PUT_MEMBER_EXCEPTION_BOOK = '/member/exceptionbook'; //예외교습 일괄수정
export const POST_EXCEL_UPLOAD_MEMBER_EXCEPTION = '/member/excel/upload/exceptionApprove'; //예외교습 엑셀업로드
export const GET_MEMBER = '/member/index';
export const GET_MEMBER_BRANCH = '/member/branch/:branch_idx';
export const GET_MEMBER_SCHOOL = '/member/school/:school_idx';
export const GET_MEMBER_NOTEACHER = '/member/school/noteacher/:school_idx';
export const GET_MEMBER_TEACHER = '/member/teacher/:teacher_idx';
export const PUT_MEMBER_TEACHER = '/member/teacher/:teacher_idx';
export const PUT_MEMBER_CURRICULUM = '/member/curriculum';
export const DELETE_MEMBER_TEACHER = '/member/teacher/delete';
export const PUT_MEMBER_REGRESS = '/member/regress';
export const PUT_MEMBER_TRANSFER = '/member/transfer'; //회원이동신청
export const POST_MEMBER_TRANSFER = 'member/transfer'; // 포스트 회원이동신청
export const PUT_MEMBER_RECESS_COMMENT = '/member/regress/approval'; // 휴회 승인/반려
export const POST_MEMBER_HANDTAKEOVER = '/memberManage/handTakeover/:apply_idx'; // 회원 인수 승인, 반려



// 일정
export const GET_SCHEDULE_HQ = '/schedule/hq/:level_no/:team_idx';
export const GET_SCHEDULE_BRANCH = '/schedule/branch/:level_no/:team_idx';
export const POST_SCHEDULE = '/schedule/index';
export const GET_SCHEDULE_DETAIL = '/schedule/:schedule_idx';
export const PUT_SCHEDULE = '/schedule/:schedule_idx';
export const DELETE_SCHEDULE = '/schedule/delete';
export const GET_SCHEDULE_LIST_TOP5 = '/schedule/list/top5'; // 신규일정목록 (5개))

// 본사
export const GET_HQ_DETAIL = '/hq/:hq_idx';
export const PUT_HQ_DETAIL = '/hq/:hq_idx';
export const GET_AUTH_ORG_LIST = '/accountManage/authOrg';
export const GET_AUTH_ACCOUNT = '/accountManage/auth';
export const GET_AUTH_ACCOUNT_CHECK = '/accountManage/authCheckedOrg/:hq_idx';
export const POST_AUTH_ACCOUNT_CHECK = '/accountManage/authCheckedOrg/:hq_idx';
export const POST_ORGMANAGE_MEMBER = '/orgManage/member';
export const PUT_ORGMANAGE_MEMBER = '/orgManage/member';
export const DELETE_ORGMANAGE_MEMBER = '/orgManage/member/:member_idx';
export const GET_MEMBER_POSITION = '/orgManage/member/position';
export const PUT_ORGMANAGE_TEAM = '/orgManage/team';
export const POST_ORGMANAGE_TEAM = '/orgManage/team';
export const DELETE_ORGMANAGE_TEAM = '/orgManage/team/:team_idx';

// 지사
export const POST_BRANCH = '/branch/index';
export const GET_BRANCH_DETAIL = '/branch/:branch_idx';
export const PUT_BRANCH = '/branch/:branch_idx';
export const GET_BRANCH_STATUS = '/branch/status/:branch_idx';
export const POST_BRANCH_ISSUE = '/branch/issue';
export const PUT_BRANCH_ISSUE = '/branch/issue/:issue_idx';
export const DELETE_BRANCH_ISSUE = '/branch/issue/:issue_idx';
export const GET_BRANCH_ISSUE = '/branch/issue';
export const GET_BRANCH_STAFF_JOB = '/branch/staff/job';
export const POST_BRANCH_STAFF_JOB = '/branch/staff/job';
export const DELETE_BRANCH_STAFF_JOB = '/branch/staff/job/:branch_idx/:roll_no/:branch_staff_idx';
export const GET_BRANCH_JOB_STAFF_LIST = '/branch/job/stafflist'; //업무별 분장가능한 직원 목록 branch_idx=171581&roll_no=3
export const GET_BRANCH_STAFF = '/branch/staff';
export const PUT_BRANCH_STAFF = '/branch/staff/:branch_idx';
export const DELETE_BRANCH_STAFF = '/branch/staff/delete';
export const POST_BRANCH_STAFF = '/branch/staff/:branch_idx';
export const GET_BRANCH_MANAGE_INFOSCHOOL = '/branch/manage/infoSchool/:branch_idx';
export const POST_ORDERFIRST = '/orderFirst/index'; // 초도물품 주문 신청
export const PUT_ORDERFIRST = '/orderFirst/index'; // 초도물품 주문 상태 일괄 수정
export const GET_BRANCH_SCHOOL_CHARGE = '/branch/schoolCharge/:branch_idx'; // 관리 - 교육원 수수료 현황
export const GET_BRANCH_SCHOOL_CHARGE_DETAIL = '/branch/schoolChargeDetail/:branch_idx/:school_idx'; // 관리 - 교육원 수수료 현황 상세

// 보고서
export const POST_REPORT_CLOSE = '/report/close/:level_no';
export const GET_REPORT_CLOSE_DETAIL = '/report/close/:level_no/:report_idx';
export const PUT_REPORT_CLOSE = '/report/close/:level_no/:report_idx';
export const GET_REPORT_PERFORMANCE_DETAIL = '/report/performance/:level_no/:report_idx';

// 교육원
export const POST_SCHOOL = '/school/index';
export const GET_SCHOOL_DETAIL = '/school/:school_idx';
export const PUT_SCHOOL = '/school/index';
export const GET_SCHOOL_INFO = '/school/info/:school_idx';
export const PUT_SCHOOL_NEWCURRICULUM = '/school/newCurriculum'; //교육원 수정(신규교육과정)
export const PUT_SCHOOL_REQUIRECURRICULUM = '/school/requireCurriculum'; //교육원 수정(필수교육과정)
export const PUT_SCHOOL_REQUESTDOC = '/school/requestDoc'; //교육원 수정(교육원요청서류)
export const PUT_SCHOOL_OPENDOC = '/school/openDoc'; //교육원 수정(교육원개점서류)
export const POST_ORDERFIRST_FIRST = '/orderFirst/first'; //교육원 1차 초도물품 신청
export const POST_ORDERFIRST_SECOND = '/orderFirst/second'; //교육원 2차 초도물품 신청
export const PUT_SCHOOL_ORDERLIMIT = '/school/orderLimit'; //교육원 수정(주문제한)
export const GET_SCHOOL_LEADER_NAME_CHECK = '/school/checkLeaderName';
export const GET_SCHOOL_CELL_PHONE_CHECK = '/school/checkPhone';
export const POST_SCHOOL_PRIVATETUTOR = '/school/privateTutor'; //개인과외/학원/교습소신고등록증 등록
export const PUT_SCHOOL_PRIVATETUTOR = '/school/privateTutor';
export const POST_SCHOOL_BUSINESSLICENSE = '/school/businessLicense'; //사업자등록증 등록
export const PUT_SCHOOL_BUSINESSLICENSE = '/school/businessLicense';

//학습진도
export const GET_MEMBER_STUDY = '/memberStudy/:member_idx/:base_year_month';

// 로그
export const POST_LOG_REQUEST = '/log/request';
export const GET_LOG_REQUEST = '/log/request/:log_idx';
export const PUT_LOG_REQUEST = '/log/request/:log_idx';
export const DELETE_LOG_REQUEST = '/log/request';
export const POST_LOG_REQUEST_PROCESS_STATUS = '/log/request/process_status/:log_idx'; // 요청 로그 처리

// SPTP
export const GET_SPTP_MANAGE = '/sptp/manage';
export const PUT_SPTP_MANAGE = '/sptp/manage/:idx';
export const POST_SPTP_INQUIRY = '/sptp/inquiry';
export const GET_SPTP_INQUIRY_DETAIL = '/sptp/inquiry/:idx';
export const PUT_SPTP_INQUIRY = '/sptp/inquiry';
export const DELETE_SPTP_INQUIRY = '/sptp/inquiry/:idx';
export const PUT_SPTP_MANAGE_RESULTDATE = '/sptp/manage/counselResultDate';
export const GET_SPTP = '/sptp/index';
export const GET_SPTP_MEMBER = '/sptp/member';
export const PUT_SPTP_DISPLAY = '/sptp/display';

// 게시판
export const POST_BOARD_TASK = '/board/task';
export const GET_BOARD_TASK_DETAIL = '/board/task/:idx';
export const PUT_BOARD_TASK = '/board/task';
export const DELETE_BOARD_TASK = '/board/task';
export const PUT_BOARD_TASK_FIX = '/board/task/fix';
export const GET_BOARD_TASK_READ_MEMBER = '/board/task/read/:idx';
export const GET_BOARD_CLASS_CATEGORY = '/board/class/category'; //수업자료전용 카테고리
export const GET_BOARD_CLASS_CATEGORY_3RD = '/board/class/category/3rd';
export const GET_BOARD_CLASS = '/board/class';
export const POST_BOARD_CLASS = '/board/class';
export const GET_BOARD_CLASS_DETAIL = '/board/class/:idx';
export const PUT_BOARD_CLASS = '/board/class';
export const DELETE_BOARD_CLASS = '/board/class';
export const POST_DELETE_BOARD_CLASS = '/board/class/delete';
export const GET_BOARD_BOARDTYPE = '/board/type';
export const GET_BOARD_READ = '/read/:idx';

// 배너
export const GET_BANNER = '/banner/index';
export const POST_BANNER = '/banner/index';
export const PUT_BANNER = '/banner/index';
export const DELETE_BANNER = '/banner/index';

// 업무서식
export const POST_FORM = '/form/index';
export const GET_FORM_DETAIL = '/form/:idx';
export const PUT_FORM = '/form/index';
export const DELETE_FORM = '/form/index';
export const PUT_FORM_FIX = '/form/fix';

// 고객센터
export const POST_CUSTOMERCENTER_INQUIRY = '/customerCenter/inquiry';
export const GET_CUSTOMERCENTER_INQUIRY_DETAIL = '/customerCenter/inquiry/:idx';
export const PUT_CUSTOMERCENTER_INQUIRY = '/customerCenter/inquiry';
export const DELETE_CUSTOMERCENTER_INQUIRY = '/customerCenter/inquiry';
export const POST_CUSTOMERCENTER_FAQ = '/customerCenter/faq';
export const GET_CUSTOMERCENTER_FAQ_DETAIL = '/customerCenter/faq/:idx';
export const PUT_CUSTOMERCENTER_FAQ = '/customerCenter/faq';
export const DELETE_CUSTOMERCENTER_FAQ = '/customerCenter/faq';
export const GET_CUSTOMERCENTER_FAQ = '/customerCenter/faq/list';
export const PUT_CUSTOMERCENTER_FAQ_SORT = '/customerCenter/faq/sort';

// 쇼핑몰관리
export const POST_SHOPPING_BOOK_PRODUCT = '/shoppingBook/index'; //교재등록
export const GET_SHOPPING_BOOK_PRODUCT_DETAIL = '/shoppingBook/:idx'; //교재상세
export const PUT_SHOPPING_BOOK_PRODUCT = '/shoppingBook/index'; //교재수정
export const GET_SHOPPING_BOOK_BOOK_CATEGORY = '/shoppingBook/book/category'; //카테고리트리 목록(children 포힘)
export const PUT_SHOPPING_BOOK_SORT = '/shoppingBook/sort'; //교재순서수정
export const DELETE_SHOPPING_BOOK = '/shoppingBook/index'; // 교재 삭제(일괄삭제);
export const POST_SHOPPING_PRODUCT = '/shoppingProduct/index'; //물품등록
export const PUT_PRODUCT = '/shoppingProduct/index'; //물품수정
export const GET_SHOPPING_PRODUCT = '/shoppingProduct/index'; //물품목록
export const GET_SHOPPING_PRODUCT_DETAIL = '/shoppingProduct/:idx'; //물품상세
export const GET_SHOPPING_PRODUCT_ORDER_DETAIL = '/shoppingProduct/order/:idx'; //물품상세-교육원
export const PUT_SHOPPING_PRODUCT = '/shoppingProduct/index'; //물품 판매상태수정 (일괄수정)
export const DELETE_SHOPPING_PRODUCT = '/shoppingProduct/index'; //물품 삭제 (일괄삭제)
export const GET_SHOPPING_PRODUCT_CATEGORY = '/shoppingProduct/product/category'; //믈픔카테고리
export const POST_SHOPPING_PRODUCT_CATEGORY = '/shoppingProduct/category';
export const PUT_SHOPPING_PRODUCT_CATEGORY = '/shoppingProduct/category';
export const DELETE_SHOPPING_PRODUCT_CATEGORY = '/shoppingProduct/category/:idx';
export const PUT_SHOPPING_PRODUCT_SALE_STATUS = '/shoppingProduct/saleStatus';
export const GET_SHOPPING_BOOK_CLASS = '/shoppingBook/book/class/:idx'; // 분류별 교재 목록
export const GET_SHOPPING_BOOK_CLASS_INVENTORY = '/shoppingBook/book/class/inventory/:idx'; // 분류별 교재 목록(재고있는것만)

// 교재 주문
export const GET_ORDERBOOK = '/orderBook/:new_order_yn';
export const GET_ORDERBOOK_ORDER_LIST = '/orderBook/order_list';
export const GET_ORDERBOOK_ORDER_DETAIL = '/orderBook/order_list/:order_idx';
export const PUT_ORDERBOOK_ORDER_INFO = '/orderBook/order_list/:order_idx';
export const PUT_ORDERBOOK_ORDER_GROUP = '/orderBook/order_list/detail_group';
export const PUT_ORDERBOOK_ORDER_GROUP_CANCEL = '/orderBook/cancel/index';
export const GET_ORDERBOOK_ORDER_CANCEL_LIST = '/orderBook/order_cancel_list';
export const GET_ORDERBOOK_ORDER_CANCEL_ITEM = '/orderBook/order_cancel_item';
export const GET_ORDERBOOK_ORDER_MODIFY_LIST = '/orderBook/order_modify_list';
export const GET_ORDERBOOK_ORDER_MODIFY_ITEM = '/orderBook/order_modify_item';
export const GET_ORDERBOOK_LIMIT_CHECK = '/orderLimit/check';
export const GET_ORDERBOOK_START_ORDER = '/orderBook/start_order/:school_idx/:teacher_idx';
export const GET_ORDERBOOK_TABLE_OPTION = '/orderBook/new/:new_order_yn/:school_idx/:teacher_idx';
export const GET_ORDERBOOK_MEMBER_CHECK = '/orderBook/check/:new_order_yn/:school_idx/:teacher_idx';
export const GET_ORDERBOOK_TABLE = '/orderBook/:new_order_yn/:school_idx/:teacher_idx/:order_no';
export const GET_ORDERBOOK_SELECT = '/orderBook/item/:book_cate1_code/:book_cate2_code/:member_idx';
export const GET_ORDERBOOK_AUTO_SELECT = '/orderBook/order_book_list/auto_fg/:book_cate1_code/:book_cate2_code/:member_idx';
export const POST_ORDERBOOK_AUTO_SELECT_ALL = '/orderBook/order_book_list/new/auto_fg';
export const GET_ORDERBOOK_TMP_CURRENT = '/orderBook/order_book_list/current/:tmp_order_no/:book_cate1_code/:book_cate2_code/:member_idx';
export const GET_ORDERBOOK_CURRENT = '/orderBook/order_book_list/current_order/:order_no/:book_cate1_code/:book_cate2_code/:member_idx';
export const POST_ORDERBOOK_TMP_CURRENT_ALL = '/orderBook/new/order_book_list/current/:tmp_order_no';
export const POST_ORDERBOOK_CURRENT_ALL = '/orderBook/new/order_book_list/current_order/:order_no';
export const POST_ORDERBOOK_SAVE_SELECT = '/orderBook/order_book_list/save/:book_cate1_code/:book_cate2_code/:new_yn/:member_idx';
export const DELETE_ORDERBOOK_REMOVE_SELECT = '/orderBook/order_book_list/remove/:tmp_order_no/:book_cate2_code/:member_idx';
export const POST_ORDERBOOK_SAVE_ETC = '/orderBook/order_book_list/save/etc';
export const POST_ORDERBOOK_SAVE = '/orderBook/order_book_list/new/save';
export const GET_ORDERBOOK_MONITERING_MEMBER_LIST = '/orderBook/order_book_list/monitering/:order_no/:tmp_order_no';
export const GET_ORDERBOOK_MONITERING_BOOK_LIST = '/orderBook/order_book_list/monitering/member/:order_no/:tmp_order_no/:member_idx';
export const POST_ORDERBOOK_MONITERING_BOOK_ALL_LIST = '/orderBook/new/order_book_list/monitering/member/:order_no/:tmp_order_no';
export const POST_ORDERBOOK_MONITERING = '/orderBook/order_book_list/monitering';
export const POST_ORDERBOOK_MONITERING_ALL = '/orderBook/new/order_book_list/monitering';
export const GET_ORDERBOOK_MONITERING_LIST = '/orderBook/order_book_list/monitering/list'; // 교재 주문 모니터링 목록
export const GET_ORDERBOOK_TMP_ORDER_LIST = '/orderBook/order_book_list/:tmp_order_no';
export const POST_ORDER_NO = '/orderBook/payment/order_no';
export const GET_TMP_ORDER_NO = '/orderBook/tmp_order_no/:order_no';
export const GET_ORDERBOOK_BUYERINFO = '/orderBook/payment/school/:school_idx';
export const POST_ORDERBOOK_PENDING_PAYMENT = '/orderBook/payment/index';
export const POST_ORDERBOOK_PAYMENT = '/orderBook/rt_url';
export const GET_ORDERBOOK_PAYMENT_DETAIL = '/orderBook/payment/:order_no';
export const POST_ORDERBOOK_REFUND = '/orderBook/modify';
export const PUT_ORDERBOOK_CANCEL = '/orderBook/cancel/:order_idx';
export const POST_ORDERBOOK_CART = '/orderBook/cart';
export const POST_ORDERBOOK_CART_ALL = '/orderBook/new/cart';
export const POST_ORDERBOOK_CART_ETC_ALL = '/orderBook/order_book_list/save/tmp/etc';
export const GET_ORDERBOOK_CART = '/orderBook/cart/:book_cate1_code/:book_cate2_code/:member_idx/:school_idx/:teacher_idx/:new_yn/:yyyy/:mm';
export const GET_ORDERBOOK_CART_ALL = '/orderBook/new/cart/:school_idx/:teacher_idx/:new_yn/:yyyy/:mm';
export const GET_ORDERBOOK_ETC_CART = '/orderBook/cart/etc/:school_idx/:teacher_idx/:new_yn/:yyyy/:mm';
export const GET_ORDERBOOK_CHANGE = '/orderChange/index';
export const GET_ORDERBOOK_MEMBER_ORDER_LIST = '/orderBook/member_order_book_list';
export const POST_ORDERBOOK_TMP_MODIFY = '/orderBook/modify/tmp_order';
export const DELETE_ORDERBOOK_TMP_MODIFY = '/orderBook/modify/tmp_order';
export const POST_ORDERBOOK_TMP_MODIFY_ALL = '/orderBook/new/modify/tmp_order';
export const DELETE_ORDERBOOK_TMP_MODIFY_ALL = '/orderBook/new/modify/tmp_order';
export const POST_ORDERBOOK_MODIFY = '/orderBook/modify/order';
export const DELETE_ORDERBOOK_MODIFY = '/orderBook/modify/order';
export const POST_ORDERBOOK_MODIFY_ALL = '/orderBook/new/modify/order';
export const DELETE_ORDERBOOK_MODIFY_ALL = '/orderBook/new/modify/order';
export const POST_ORDERBOOK_EXCHANGE = '/orderBook/exchange/order';
export const PUT_ORDERBOOK_STATUS = '/orderBook/statusChange';
export const POST_ORDERBOOK_MEMBER_MEMO_LIST = '/orderBook/member_memo';
export const GET_NEWSLETTER_PERIOD = '/orderBook/check_newsletter_period';

// 모니터링
export const GET_ORDERBOOK_MONITORING_LIST = '/orderBook/member_order_book_list';
export const POST_ORDERBOOK_MONITORING_MEMO = '/orderBook/bookWatch'; // 메모 저장
export const POST_ORDERBOOK_MONITORING_STATUS = '/orderBook/watch_status'; // 모니터링 승인여부/사유 수정

// 환불
export const GET_ORDERBOOK_REFUND_LIST = '/orderBook/order_refund_list';
export const GET_ORDERPRODUCT_REFUND_LIST = '/orderProduct/order_refund_list';
export const PUT_ORDERBOOK_REFUND_STATUS = '/orderBook/orderBookRefund/statusChange';
export const POST_ORDERBOOK_REFUND_STATUS = '/orderBookRefund/refund/status';

// 환불요청에외승인 
export const PUT_ORDERBOOK_CHANGE_REFUND_EXCEPTION= '/orderBookRefund/changeRefundException';


// 물품주문
export const GET_ORDERPRODUCT_TMP_ORDER_NO = '/orderProduct/tmp_order_no';
export const POST_ORDERPRODUCT_ORDER = '/orderProduct/order';
export const POST_ORDERPRODUCT_CART = '/orderProduct/cart';
export const DELETE_ORDERPRODUCT_CART = '/orderProduct/cart';
export const POST_ORDERPRODUCT_CART_EA = '/orderProduct/cart/:cart_idx'; // 물품 주문 장바구니 수량 수정
export const GET_ORDERPRODUCT_CART = '/orderProduct/cart/list';
export const GET_ORDERPRODUCT_TMP_ORDER = '/orderProduct/order/:tmp_order_no';
export const POST_ORDERPRODUCT_PAYMENT = '/orderProduct/rt_url';
export const GET_ORDERPRODUCT_PAYMENT_DETAIL = '/orderProduct/payment/:order_no';
export const GET_ORDERPRODUCT_DETAIL = '/orderProduct/refund/detail/:order_no';
export const PUT_ORDERPRODUCT_CANCEL = '/orderProduct/cancel/:order_idx';
export const POST_ORDERPRODUCT_MODIFY = '/orderProduct/modify';
export const GET_ADMIN_ORDERPRODUCT_DETAIL = '/orderProduct/detail/:order_no';
export const PUT_ORDERPRODUCT_DELIVERY_ADDR = '/school/school_delivery_addr'; // 물품주문시 회원정보 업데이트 체크후 배송지 업데이트;

// 주문 수정/취소/교환
export const POST_ORDERCHANGE_MODIFY_STATUS = '/orderChange/modify_status'; // 처리상태 수정
export const PUT_ORDERCHANGE_BRANCH_APPROVAL = '/orderChange/branch/approval '; // 지사 메모 수정 (승인/반려)
export const POST_ORDERCHANGE_APPROVAL = '/orderChange/approval_yn'; // 관리자 승인
export const POST_ORDERCHANGE_PAYMENT = '/orderBook/Add/rt_url'; // 교재주문 수정/교환 결제
export const GET_ORDERCHANGE_DELIVERY_LIST = '/orderChange/deliveryinfo'; //엑셀 배송용 출력

// 회수관리
export const GET_ORDER_COLLECT = '/orderBook/order_collect_list'; // 회수 목록
export const GET_ORDER_COLLECT_PERIOD = '/orderBook/order_collect_list/period'; // 회수요청일 목록
export const GET_ORDER_COLLECT_BOOK_LIST = '/orderBook/order_collect_list/collect_book_list'; //회수관리-회수교재내역(엑셀)
export const POST_ORDER_COLLECT_MEMO_FILE = '/orderBook/order_collect/memo_file'; // 메모/첨부파일 수정
export const POST_ORDER_COLLECT_DAMAGE = '/orderBook/order_collect/damage'; // 파본여부 수정
export const POST_ORDER_COLLECT_USE_POINT = '/orderBook/order_collect/use_point_yn'; // 적립금 차감 여부 수정
export const POST_ORDER_COLLECT_MEMO_ADMIN = '/orderBook/order_collect/memo_admin'; // 본사메모 수정
export const GET_ORDER_COLLECT_DELIVERY = '/orderBook/delivery_payment_list'; // 배송비 상세 목록
export const POST_ORDER_COLLECT_DELIVERY_PAY_YN = '/orderBook/delivery_payment_yn/:delivery_payment_idx'; // 배송비 결제여부 수정
export const GET_ORDER_COLLECT_NOTICE = '/orderBook/collect_notice_list'; // 회수 진행시 확인 사항 상세
export const POST_ORDER_COLLECT_NOTICE = '/orderBook/collect_notice'; // 회수 진행시 확인 사항 수정
export const GET_ORDER_COLLECT_DELIVERY_NOTICE = '/orderBook/delivery_notice_list'; // 배송 관련 공지사항 상세
export const POST_ORDER_COLLECT_DELIVERY_NOTICE = '/orderBook/delivery_notice'; // 배송 관련 공지사항 수정
export const GET_ORDER_COLLECT_HISTORY = '/orderBook/modify_history/:order_modify_idx'; // 진행상태 이력 목록
export const POST_ORDER_COLLECT_CANCEL = '/orderBook/cancel_refund/:order_modify_idx/:request_status'; // 회수 취소 신청
export const POST_ORDER_COLLECT_PAYMENT = '/orderBook/Delevery/rt_url'; // 회수 결제
export const GET_ORDER_COLLECT_DELIVERY_LIST = '/orderBook/order_collect_list/deliveryinfo'; //엑셀 배송용 출력(회수관리)

// 수업 승인 요청
export const POST_CLASSREQUEST = '/classRequest/index'; // 예외교습 승인/반려

// 교육원 주문현황
export const GET_TOTAL_ORDER_MEMBER = '/orderBook/total/order/member/:branch_idx/:school_idx/:teacher_idx/:yyyymm'; // 총주문 회원 목록
export const GET_NOT_ORDER_MEMBER = '/orderBook/not/order/member/:branch_idx/:school_idx/:teacher_idx/:yyyymm'; // 미주문 회원 목록
export const GET_DEL_REQUEST_MEMBER = '/orderBook/del_member/:branch_idx/:school_idx/:teacher_idx/:yyyymm'; // 휴회/졸업(삭제) 신청 회원 목록

// 적립금 장바구니
export const GET_ORDER_POINT = '/point/index';
export const GET_ORDER_POINT_CART = '/point/cart'; // 적립금 장바구니 목록
export const GET_ORDER_POINT_CART_SCHOOL = '/point/cart/school'; // 적립금 장바구니 조회 교육원 목록
export const DELETE_ORDER_POINT_CART = '/point/cart'; // 적립금 장바구니 삭제
export const POST_ORDER_POINT_CART = '/point/cart'; // 적립금 장바구니 추가
export const POST_ORDER_POINT_CART_GIVE = '/point/cart/index'; // 적립금 장바구니 적립금 지급(일괄적립)
export const POST_EXCEL_UPLOAD_POINT_CART = '/common/excel/upload/pointcart';

// 주문제한
export const GET_ORDER_LIMIT = '/orderLimit/index'; // 주문 제한 기간 설정 목록
export const POST_ORDER_LIMIT = '/orderLimit/index'; // 주문 제한 기간 사용여부/기간 수정

// 소식지 기한 설정
export const POST_NEWSLETTER_DATE = '/orderBook/newsletter_period';
export const POST_NEWSLETTER_DATE_ALL = '/orderBook/newsletter_period/all';

// 배송
export const GET_DELIVERY_SUPPORT = '/deliverySupport/index'; // 배송비 지원 목록
export const POST_DELIVERY_SUPPORT = '/deliverySupport/support'; // 배송비 지원/중단

//재고관리
export const POST_STOCKBOOK_INVENTORY = '/stockBook/inventory';
export const GET_STOCKBOOK_INVENTORY = '/stockBook/inventory';
export const GET_STOCKBOOK_SALE_DETAIL = '/stockBook/sale/:product_cd/:order_date'; //교재 재고 상세-판매
export const GET_STOCKBOOK_REFUND_DETAIL = '/stockBook/refund/:product_cd/:order_date'; //교재 재고 상세-환불
export const GET_STOCKBOOK_DAMAGEBOOK_DETAIL = '/stockBook/damagebook/:product_cd/:order_date'; //교재 재고 상세-파본
export const POST_STOCKBOOK_EXCEL_UPLOAD = '/stockBook/excel/upload/:register_date'; // 교재 일괄 등록 엑셀 업로드

export const POST_STOCKPRODUCT_INVENTORY = '/stockProduct/inventory';
export const GET_STOCKPRODUCT_INVENTORY = '/stockProduct/inventory';
export const GET_STOCKPRODUCT_SALE_DETAIL = '/stockProduct/sale/:product_cd/:base_date'; //물품 재고 상세-판매
export const GET_STOCKPRODUCT_REFUND_DETAIL = '/stockProduct/refund/:product_cd/:base_date'; //물품 재고 상세-환불
export const POST_STOCKPRODUCT_EXCEL_UPLOAD = '/stockProduct/excel/upload/:register_date'; // 물품 일괄 등록 엑셀 업로드


// 통계
export const SCHOOL_STATISTICS_TOTAL = '/school/statistics/total';
export const SCHOOL_STATISTICS_LIST = '/school/statistics/list';
export const SCHOOL_STATISTICS_MEMBER = '/school/statistics/member';
export const SCHOOL_STATISTICS_SALES = '/school/statistics/sales';

// 마감보고서 관리 - 교육원
export const SCHOOLCLOSINGREPORT_LIST = '/schoolClosingReport/list';
export const SCHOOLCLOSINGREPORT_DETAIL = '/schoolClosingReport/detail';
export const POST_SCHOOLCLOSINGREPORT_DETAIL = '/schoolClosingReport/update';
export const POST_SCHOOLCLOSINGREPORT = '/schoolClosingReport/:report_idx';

// 마감보고서 관리 - 지사
export const GET_BRANCH_CLOSING_REPORT_DETAIL = '/branchClosingReport/detail';
export const GET_BRANCH_CLOSING_REPORT_LIST = '/branchClosingReport/list';
// 마감보고서 관리 - 지사 실적마감보고서 수정
export const POST_BRANCH_CLOSING_REPORT_PER_UPDATE = '/branchClosingReport/per_update';
// 마감보고서 관리 - 지사 마감보고서 수정
export const POST_BRANCH_CLOSING_REPORT_UPDATE = '/branchClosingReport/update';
// 지사 마감보고서 승인/반려
export const POST_HQ_BRANCH_CLOSINGREPORT = '/hq/branch/closingReport';

// 지사별 교육원 목록
export const GET_BRANCH_SCHOOL_LIST = '/branch/school';
// 교육원별 회원 목록
export const GET_SCHOOL_MEMBER_LIST = '/branch/school/member';
// 회원별 교육과정과목
export const GET_MEMBER_CURRICULUM_LIST = '/branch/school/member/curriculum';

// 수업승인요청 예외교습 신청
export const POST_EXCEPTION_REQUEST = '/branch/school/member/curriculum';

// 교육원 - 회원 수업시간 수정
export const PUT_SCHOOL_MEMBER_CLASS_TIME = '/member/class/time';
